import React from 'react';
import ContentLoader from 'react-content-loader';

const CartStepsSkeleton = ({ ...rest }) => (
  <ContentLoader
    speed={1.4}
    width="100%"
    backgroundColor="var(--neutral-200)"
    foregroundColor="var(--neutral-400)"
    className="cart-steps-skeleton mx-auto w-full max-w-[175px] md:max-w-[850px] h-[140px] md:h-[24px]"
  >
    <rect x="0" y="0" rx="4" ry="4" height="100%" width="100%" />
  </ContentLoader>
);

export default CartStepsSkeleton;
